import AppNavbar from "./AppNavbar";
import Footer from "./Footer";
import '../../assets/css/profile.scss'
import profileImg from '../../assets/images/dashboard/profileImg.jpg'
import ProfileAddressEditModal from "./ProfileAddressEditModal";
import { useEffect, useState } from "react";
import { loadDeleteAccount, loadProfileData, postAddressDataData, postProfileUpdate } from "../redux/action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import { capitalizeFirstLetter, getInitials } from "../CommonFile/Function_utils";
import { Button, Modal } from "react-bootstrap";
import ResetPasswordComponent from "./ResetPasswordComponent";
import * as HeaderAuthentication from '../../components/HeaderAuthentication';
import Swal from "sweetalert2";

const Profile = () => {

    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;

    const { profileData } = useSelector((state) => state.data);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [phoneValid, setPhoneValid] = useState(false);
    const [saveChanges, setSaveChanges] = useState(false);
    const [enableProfile, setEnableProfile] = useState(false)
    const [enableaddress, setEnableaddress] = useState(false)
    const [dataStatus, setDataStatus] = useState(false)
    const [showAddToListModal, setShowAddToListModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [show, setShow] = useState(false);

    const fetchProfileData = () => {
        dispatch(loadProfileData(signInID, setLoading))
    }

    const [profileInputs, setProfileInputs] = useState({
        name: "", email: "", phone: "", company: "", address_line_1: "",
        address_line_2: "", area: "", city: "", state: "", country: "",
        postal_code: "",
    })

    useEffect(() => {
        fetchProfileData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log(profileData, "profileData")
        if (profileData && Object.keys(profileData).length > 0) {
            setProfileInputs({
                name: profileData?.name.trim(), email: profileData?.email.trim(), phone: profileData?.phone.trim(), company: profileData?.company_name.trim(),
                address_line_1: profileData?.address?.address_line_1.trim(),
                address_line_2: profileData?.address?.address_line_2.trim(), area: profileData?.address?.admin_area_1.trim(),
                city: profileData?.address?.admin_area_2.trim(), state: profileData?.address?.state.trim(),
                country: profileData?.address?.country.trim(),
                postal_code: profileData?.address?.postal_code.trim(),
            })
            setDataStatus(true)
        }
    }, [profileData])

    // reion handle input
    const inputHandle = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        if (name === "phone") {
            // Allow only digits
            setPhoneValid(false);
            newValue = value.replace(/\D/g, "");
        }

        setProfileInputs((prev) => ({
            ...prev,
            [name]: newValue,
        }))

        setErrors((prev) => ({ ...prev, [name]: '' }));

        setSaveChanges(true)
    }

    const checkPhoneNumber = () => {
        if (profileInputs.phone && profileInputs.phone.length < 10) {
            setPhoneValid(true);
        }
    }

    const onHide = () => setShowAddToListModal(false)
    // endregion

    // region update profile data
    const profileSubmit = () => {

        const requestPayload = {
            name: profileInputs.name,
            phone: profileInputs.phone,
            company: profileInputs.company,
            user_id: parseInt(signInID)
        };

        const requestOption = {
            method: 'POST',
            mode: 'cors',
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };

        dispatch(postProfileUpdate(requestOption, fetchProfileData, setEnableProfile));
    };
    // endregion
    // endregion

    // region submit address update
    const [errors, setErrors] = useState({});
    const handleSubmit = () => {
        const newErrors = {};
        if (!profileInputs.address_line_1) newErrors.address_line_1 = 'Address 1 is required';
        if (!profileInputs.country) newErrors.country = 'Country is required';
        if (!profileInputs.postal_code) newErrors.postal_code = 'Postal Code is required';

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        const requestPayload = {
            address_line_1: profileInputs.address_line_1,
            address_line_2: profileInputs.address_line_2,
            country: profileInputs.country || '',
            admin_area_1: profileInputs.area || '',
            admin_area_2: profileInputs.city || '',
            state: profileInputs.state || '',
            postal_code: profileInputs.postal_code,
            user_id: parseInt(signInID),
            country_code: "",
        };

        const requestOption = {
            method: 'POST',
            mode: 'cors',
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };

        dispatch(postAddressDataData(requestOption, fetchProfileData, setEnableaddress));
    };
    // endregion

    // region handle delte account
    const [deleteStatus, setDeleteStatus] = useState(false);
    const handleDeleteAccount = () => {
        setDeleteStatus(true);
        const postDelete = {
            user_id: parseInt(signInDetails[0].id),
            sbn_id: signInDetails[0].sbn_id,
            role: signInDetails[0].role,
        }

        console.log(postDelete)

        const requestOption = {
            method: 'DELETE',
            mode: 'cors',
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(postDelete),
        };
        dispatch(loadDeleteAccount(requestOption)).then((resp) => {
            if (resp.status_code === 200) {
                setDeleteStatus(false);
                closeModal();

                Swal.fire({
                    title: 'Success',
                    text: resp.message,
                    icon: 'success',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: true
                }).then((result) => {
                    if (result.isConfirmed) {

                        // Clear session storage

                        sessionStorage.clear();
                        localStorage.clear();
                        // Redirect
                        window.location.href = "/";
                    }
                });
            } else {
                // toast.error(resp.Error);
                closeModal();
                const errorMessage = resp.message;
                Swal.fire({
                    title: 'Failed',
                    text: errorMessage,
                    icon: 'error',
                });
            }
        })
            .catch((err) => { console.log(err) });
    }

    const closeModal = () => {
        setShow(false);
    }
    // endregion

    return (
        <div className="page-layout">
            <AppNavbar />
            <div className="page-content">
                <div className="profile-details-container">
                    <div className="profile-page">
                        <div className="profile-sidebar">
                            <h3>Account Settings</h3>

                            <ul>
                                <li className="active">
                                    <i className="fas fa-user"></i>
                                    Personal Info
                                </li>

                                {/* <li>
                                    <i className="fas fa-shield-alt"></i>
                                    Security
                                </li>

                                <li>
                                    <i className="fas fa-check-circle"></i>
                                    Verification
                                </li>

                                <li>
                                    <i className="fas fa-credit-card"></i>
                                    Subscription
                                </li>

                                <li>
                                    <i className="fas fa-history"></i>
                                    Activity
                                </li> */}
                            </ul>
                        </div>

                        <div className="profile-content">
                            <div className="profile-header">
                                <div className="profile-user">

                                    <div className="profile-avatar">
                                        {dataStatus && getInitials(profileData?.name.trim())}
                                    </div>

                                    <div className="profile-info">

                                        <div className="profile-name">
                                            <div>
                                                <h2>{dataStatus && profileData?.name.trim()}</h2>
                                                <p className="designation">{dataStatus && profileData?.role.trim().toUpperCase()}</p>
                                                <span className="sbn-id">{dataStatus && profileData?.sbn_id.trim()}</span>
                                            </div>
                                        </div>

                                        <div className="profile-meta">

                                            <div className="meta-item">
                                                <i className="bx bx-envelope"></i>
                                                <span>{dataStatus && (profileData?.email.trim() || "Not Available")}</span>
                                            </div>

                                            <div className="meta-item">
                                                <i className="bx bx-phone"></i>
                                                <span>{dataStatus && (profileData?.phone.trim() || "Not Available")}</span>
                                            </div>

                                            {/* <div className="meta-item">
                                                <i className="bx bx-map"></i>
                                                <span>India</span>
                                            </div> */}

                                            <div className="meta-item">
                                                <i className="bx bx-calendar"></i>
                                                <span>Member Since {dataStatus && moment(profileData?.start_date.trim()).format("DD MMM YYYY")}</span>
                                            </div>

                                            <div className="meta-item">
                                                <i className="bx bx-crown"></i>
                                                <span className="sbn-id">{dataStatus && capitalizeFirstLetter(profileData?.current_plan.trim())} Plan</span>
                                            </div>

                                            <div className="meta-item">
                                                <i className="bx bx-time"></i>
                                                <span>Expires {dataStatus && moment(profileData?.end_date.trim()).format("DD MMM YYYY")}</span>
                                            </div>

                                            <div className="meta-item">
                                                <i className="bx bx-log-in-circle"></i>
                                                <span>Last Login Today {dataStatus && moment(profileData?.last_login?.login_time.trim()).format("HH:SS A")}</span>
                                            </div>

                                            {/* <div className="meta-item verified">
                                                <i className="bx bx-check-shield"></i>
                                                <span>Email Verified</span>
                                            </div> */}

                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className="profile-grid">

                                <div className="profile-card">
                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-4">
                                        <div className="d-flex align-items-center gap-2 mb-4">
                                            <h4 className="m-0">Personal Information</h4>
                                            <i className="fa fa-edit edit_icon_btn" onClick={() => setEnableProfile((prev) => !prev)}></i>
                                        </div>

                                        {enableProfile && <button className="save-btn"
                                            onClick={profileSubmit}>
                                            Save Changes
                                        </button>}
                                    </div>

                                    <div className="form-grid">
                                        <div>
                                            <label>Full Name</label>
                                            <input type="text" className={`${enableProfile && "focus-input"}`} name="name" value={profileInputs.name}
                                                onChange={(e) => inputHandle(e)} disabled={!enableProfile} />
                                        </div>

                                        <div>
                                            <label>Email</label>
                                            <input type="email" name="email" value={profileInputs.email}
                                                onChange={(e) => inputHandle(e)} disabled />
                                        </div>

                                        <div>
                                            <label>Phone Number</label>
                                            <input type="text" name="phone"
                                                className={`${enableProfile && "focus-input"}`}
                                                maxLength={10} value={profileInputs.phone}
                                                onBlur={checkPhoneNumber} disabled={!enableProfile}
                                                onChange={(e) => inputHandle(e)} />
                                            {phoneValid && <p className="m-0" style={{
                                                color: "red",
                                                fontSize: "11px"
                                            }}>Phone should be 10 numbers</p>}
                                        </div>
                                        <div>
                                            <label>Company</label>
                                            <input type="text" className={`${enableProfile && "focus-input"}`} name="company" value={profileInputs.company}
                                                disabled={!enableProfile}
                                                onChange={(e) => inputHandle(e)} />
                                        </div>
                                    </div>
                                </div>

                                <div className="profile-card">
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <h4 className="m-0">Login & Security</h4>
                                    </div>

                                    <div className="security-item">
                                        <span>Password: <input className="pswd-input" type={showPassword ? "text" : "password"} value={dataStatus && profileData?.password.trim()}
                                            disabled /> &nbsp;&nbsp;
                                            {/* <i
                                                className={`fa ${!showPassword ? "fa-eye-slash" : "fa-eye"} pswd-icon`}
                                                onClick={() => setShowPassword(!showPassword)}
                                            ></i> */}
                                        </span>
                                        <button onClick={() => setShowAddToListModal(true)}>Change Password</button>
                                    </div>

                                    <div className="security-item">
                                        <span>Delete Account?</span>
                                        <button className="dlt-account-btn" onClick={() => setShow(true)}>Delete</button>
                                    </div>
                                </div>

                                <div className="profile-card">
                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-4">
                                        <div className="d-flex align-items-center gap-2 mb-4">
                                            <h4 className="m-0">Address</h4>
                                            <i className="fa fa-edit edit_icon_btn"
                                                onClick={() => setEnableaddress((prev) => !prev)}></i>
                                        </div>

                                        {enableaddress && <button className="save-btn"
                                            onClick={handleSubmit}>
                                            Save Changes
                                        </button>}
                                    </div>

                                    <div className="form-grid">
                                        <div>
                                            <label>Address line 1</label>
                                            <input type="text" name="address_line_1"
                                                className={`${enableaddress && "focus-input"}`}
                                                disabled={!enableaddress}
                                                value={profileInputs.address_line_1}
                                                onChange={(e) => inputHandle(e)} />
                                            {errors.address_line_1 && <div className="text-danger">{errors.address_line_1}</div>}
                                        </div>

                                        <div>
                                            <label>Address line 2</label>
                                            <input type="email" name="address_line_2" value={profileInputs.address_line_2}
                                                onChange={(e) => inputHandle(e)}
                                                className={`${enableaddress && "focus-input"}`}
                                                disabled={!enableaddress} />
                                        </div>

                                        <div>
                                            <label>Area</label>
                                            <input type="text" name="area" value={profileInputs.area}
                                                onChange={(e) => inputHandle(e)}
                                                className={`${enableaddress && "focus-input"}`}
                                                disabled={!enableaddress} />
                                        </div>

                                        <div>
                                            <label>City</label>
                                            <input type="text" name="city" value={profileInputs.city}
                                                onChange={(e) => inputHandle(e)}
                                                className={`${enableaddress && "focus-input"}`}
                                                disabled={!enableaddress} />
                                        </div>
                                        <div>
                                            <label>State</label>
                                            <input type="text" name="state" value={profileInputs.state}
                                                onChange={(e) => inputHandle(e)}
                                                className={`${enableaddress && "focus-input"}`}
                                                disabled={!enableaddress} />
                                        </div>
                                        <div>
                                            <label>Country</label>
                                            <input type="text" name="country" value={profileInputs.country}
                                                onChange={(e) => inputHandle(e)}
                                                className={`${enableaddress && "focus-input"}`}
                                                disabled={!enableaddress} />
                                            {errors.country && <div className="text-danger">{errors.country}</div>}
                                        </div>
                                        <div>
                                            <label>Postal Code</label>
                                            <input type="text" name="postal_code" value={profileInputs.postal_code}
                                                onChange={(e) => inputHandle(e)}
                                                className={`${enableaddress && "focus-input"}`}
                                                disabled={!enableaddress} />
                                            {errors.postal_code && <div className="text-danger">{errors.postal_code}</div>}
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="profile-card">
                                    <div className="d-flex align-items-center gap-2 mb-4">
                                        <h4 className="m-0">Current Subscription</h4>
                                    </div>

                                    <div className="subscription-box">
                                        <h2>Professional Plan</h2>
                                        <p>Valid Until Dec 31, 2026</p>

                                        <div className="credits">
                                            <div>
                                                <h3>15,000</h3>
                                                <span>Total Credits</span>
                                            </div>

                                            <div>
                                                <h3>8,250</h3>
                                                <span>Used Credits</span>
                                            </div>

                                            <div>
                                                <h3>6,750</h3>
                                                <span>Remaining</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="profile-card full-width">
                                    <h4>Recent Login Activity</h4>

                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>IP Address</th>
                                                <th>Device</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>25 Jun 2026</td>
                                                <td>192.168.1.1</td>
                                                <td>Chrome Windows</td>
                                                <td>
                                                    <span className="badge-success">
                                                        Success
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>24 Jun 2026</td>
                                                <td>192.168.1.2</td>
                                                <td>Firefox Linux</td>
                                                <td>
                                                    <span className="badge-success">
                                                        Success
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> */}

                            </div>
                        </div>
                    </div>

                </div>
                <ProfileAddressEditModal
                    show={showAddressModal}
                    handleClose={() => setShowAddressModal(false)}
                    fetchProfileData={fetchProfileData}
                    signInID={signInID}
                />
            </div>
            <Footer />

            {showAddToListModal && <Modal
                show={showAddToListModal}
                onHide={onHide}
                centered
                size="md"
                className="add-to-list-modal"
            >

                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-center">
                        <ResetPasswordComponent onHide={onHide} />
                    </div>
                </Modal.Body>
            </Modal>}

            <Modal
                show={show}
                onHide={onHide}
                centered
                size="md"
                className="delete-account-modal"
            >
                <Modal.Body>
                    <div className="text-center py-4 px-3">

                        <div
                            className="d-inline-flex align-items-center justify-content-center"
                            style={{
                                width: "80px",
                                height: "80px",
                                borderRadius: "50%",
                                background: "#FEE2E2",
                                color: "#DC2626",
                                fontSize: "42px"
                            }}
                        >
                            <i className="fa fa-trash"></i>
                        </div>

                        <h3 className="mt-4 fw-bold text-center">
                            Delete Account?
                        </h3>

                        <p className="text-muted mb-1">
                            This action cannot be undone.
                        </p>

                        <p className="text-muted mb-4">
                            Deleting your account will permanently remove your profile,
                            saved data, subscriptions, and all associated information.
                            Please make sure you want to continue.
                        </p>

                        <div className="d-flex justify-content-center gap-3">

                            <Button
                                variant="danger"
                                onClick={handleDeleteAccount}
                                className="px-4 fw-semibold"
                                disabled={deleteStatus}
                            >
                                <i className="fa fa-trash me-2"></i>
                                {deleteStatus ? "Deleting..." : "Delete Account"}
                            </Button>

                            <Button
                                variant="outline-secondary"
                                onClick={closeModal}
                                className="px-4"
                            >
                                Cancel
                            </Button>

                        </div>

                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
export default Profile;